import { Sun } from 'lucide-react'
import { useEffect, useRef, useState } from 'react'

interface AppBarProps {
  energy?: number
}

export function AppBar({ energy = 0 }: AppBarProps) {
  const prevEnergyRef = useRef(energy)
  const [delta, setDelta] = useState<number | null>(null)
  const [displayEnergy, setDisplayEnergy] = useState(energy)

  useEffect(() => {
    const prev = prevEnergyRef.current
    prevEnergyRef.current = energy
    if (prev === energy) return

    const diff = energy - prev
    setDelta(diff)
    const timer = setTimeout(() => setDelta(null), 2000)
    return () => clearTimeout(timer)
  }, [energy])

  useEffect(() => {
    if (displayEnergy === energy) return
    const step = energy > displayEnergy ? 1 : -1
    const timer = setInterval(() => {
      setDisplayEnergy((prev) => {
        if (prev === energy) {
          clearInterval(timer)
          return prev
        }
        return prev + step
      })
    }, 50)
    return () => clearInterval(timer)
  }, [energy, displayEnergy])

  return (
    <header className="wefa-app-bar">
      <div className="wefa-app-bar__inner">
        <span aria-hidden className="wefa-app-bar__icon">
          <Sun size={18} strokeWidth={2} />
        </span>
        <span className="wefa-app-bar__label">ENERGY</span>
        <span className="wefa-app-bar__value" aria-live="polite" data-low={energy < 5}>
          {displayEnergy.toLocaleString()}
          {delta !== null ? (
            <span className="wefa-app-bar__delta" data-tone={delta > 0 ? 'gain' : 'loss'}>
              {delta > 0 ? `+${delta}` : delta}
            </span>
          ) : null}
        </span>
      </div>
    </header>
  )
}
